import { apiClientVersioned, returnData } from '../index'

import type { IPaginatedResponse } from '../index'
import type { IModel } from '../types/model'

export const ModelsApi = {
  list: (params?: { page?: number; size?: number }) =>
    returnData(
      apiClientVersioned.get<IPaginatedResponse<IModel>>('/llms', {
        params,
      }),
    ),
}
